<div>

  @if(!btnOptions().disabled){
    <ncp-button
      #btn
      [options]="btnOptions()"
    />
  }

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="med_img_form"
      name="med_img_form"
      [formGroup]="form"
      #frm="ngForm"
      class="d-flex flex-column gap-3"
    >

      <ncp-text-area #reason [(options)]="reasonOptions" />

    </form>

    <div class="mt-3">
      {{ translations.confirm_disable }}
    </div>
  </ncp-modal>

</div>
